import { render, staticRenderFns } from "./EditPaket.vue?vue&type=template&id=05a773e8&scoped=true"
import script from "./EditPaket.vue?vue&type=script&lang=js"
export * from "./EditPaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a773e8",
  null
  
)

export default component.exports